import React from 'react';
import FullBlockingModal from './FullBlockingModal';
import { Button } from './Button';

interface GenericInformationModalProps {
  title: string;
  message: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  errorDetails?: string;
  closeButtonLabel: string;
  confirmButtonLabel?: string;
}

const GenericInformationModal: React.FC<GenericInformationModalProps> = ({
  title,
  message,
  onClose,
  onConfirm,
  errorDetails,
  closeButtonLabel,
  confirmButtonLabel,
}) => {
  return (
    <FullBlockingModal innerClassName="md:max-w-[72rem]">
      <h2 className="text-2xl md:text-3xl font-bold text-secondary mb-6">{title}</h2>
      <p className="mt-10 text-sm text-secondary mb-1">{message}</p>
      {errorDetails && <p className="mt-3 text-sm text-high-contrast-error">{errorDetails}</p>}

      <div className="flex flex-col flex-wrap md:flex-row justify-end gap-4 mt-6">
        <Button
          className="font-bold rounded-full px-8 py-2 w-full md:w-auto md:mt-0"
          variant={onConfirm ? 'simple-text' : 'primary'}
          onClick={() => {
            onClose();
          }}
          type="button"
        >
          {closeButtonLabel}
        </Button>

        {onConfirm && (
          <Button
            className="font-bold rounded-full px-8 py-2 w-full md:w-auto md:mt-0"
            variant="primary"
            onClick={onConfirm}
            type="button"
          >
            {confirmButtonLabel}
          </Button>
        )}
      </div>
    </FullBlockingModal>
  );
};

export default GenericInformationModal;
